<template>
  <div>
    <div v-if="isDesktop" class="custom-scrollbar custom-desktop-banner" :style="`max-height: calc(100vh - ${getHeaderHeight})`">
      <div v-if="product.desktop_full_banner">
        <div v-if="isFirstDesktopVideo">
          <VideoPlayer :playVideo="true" :playNewDesign="bannerPlaceHolderForVideoAutoplay" :src="product.desktop_banner_video_urls[0]" />
        </div>
        <img :src="prdImg + product.desktop_full_banner_image" alt="" />
      </div>
      <div v-else>
        <div v-for="(banner, index) in bannerImages" :key="index">
          <div v-if="isVideo(banner)">
            <VideoPlayer :playVideo="true" :playNewDesign="bannerPlaceHolderForVideoAutoplay" :src="banner" />
          </div>
          <div v-else>
            <img :src="prdImg + banner" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="custom-mobile-banner">
      <div v-if="isFirstVideo">
        <VideoPlayer :playVideo="true" :playNewDesign="bannerPlaceHolderForVideoAutoplay" :src="product.banner_video_urls[0]" />
      </div>
      <div v-if="product.app_full_banner">
        <img :src="prdImg + product.app_full_banner_image" alt="" />
      </div>
      <div v-else>
        <div v-for="(banner, index) in categoryWiseImages" :key="index">
          <div v-if="isVideo(banner)">
            <VideoPlayer :playVideo="true" :playNewDesign="bannerPlaceHolderForVideoAutoplay" :src="banner" />
          </div>
          <div v-else>
            <img :src="prdImg + banner" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import VideoPlayer from './VideoPlayer.vue'
  import {mapGetters} from 'vuex'
  export default {
    name: 'NewDesignBanner',
    props: {
      product: Object,
      isDesktop: Boolean,
      categoryWiseImages: Array
    },
    data () {
      return {
        prdImg: process.env.IMG_BASE_URL + process.env.PRODUCT_DETAIL_IMG,
        bannerImages: []
      }
    },
    computed: {
      ...mapGetters({
        bannerPlaceHolderData: 'bannerPlcaeHolderData'
      }),
      isFirstVideo: function () {
        return this.product.show_banner_video && this.product.banner_video_urls.length
      },
      isFirstDesktopVideo: function () {
        return this.product.show_banner_video && this.product.desktop_banner_video_urls.length
      },
      getHeaderHeight: function () {
        let navBar = document.getElementsByClassName('navbar')[0]
        if (navBar) {
          let navbarHeight = navBar.offsetHeight
          let totalHeight = navbarHeight + 148 + 'px'
          return totalHeight
        }
      },
      bannerPlaceHolderForVideoAutoplay: function () {
        const autoplay = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData => bannerData.placeholder_for.toLowerCase() === 'PDP'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'NEWDESIGN_PDP_VIDEO_WEB'.toLowerCase())
        if (autoplay) {
          return 'isAutoplay'
        }
        return 'stopAutoplay'
      }
    },
    mounted () {
      this.desktopImages()
    },
    components: { VideoPlayer },
    methods: {
      desktopImages: function () {
        const desktopImages = JSON.parse(this.product.desktop_images)
        const bannerVideoUrls = this.product.desktop_banner_video_urls
        const bannerVideoPosition = this.product.banner_video_indexes.map(Number)
        const combinedBannerData = []
        if (this.product.show_banner_video && bannerVideoPosition.length) {
          let videoIndex = 0
          let desktopIndex = 0
          for (let i = 1; i <= bannerVideoPosition[bannerVideoPosition.length - 1]; i++) {
            if (bannerVideoPosition.includes(i)) {
              if (videoIndex < bannerVideoUrls.length) {
                combinedBannerData.push(bannerVideoUrls[videoIndex])
                videoIndex++
              }
            } else {
              if (desktopIndex < desktopImages.length) {
                combinedBannerData.push(desktopImages[desktopIndex])
                desktopIndex++
              }
            }
          }
          while (desktopIndex < desktopImages.length) {
            combinedBannerData.push(desktopImages[desktopIndex])
            desktopIndex++
          }
          this.bannerImages = combinedBannerData
        } else if (!bannerVideoPosition.length && bannerVideoUrls.length) {
          this.bannerImages = [...bannerVideoUrls, ...desktopImages]
        } else {
          this.bannerImages = desktopImages
        }
      },
      isVideo: function (item) {
        return /\.m3u8$/.test(item)
      }
    }
  }
</script>
<style lang="css" scoped>
.custom-scrollbar {
    scrollbar-width: 5px;
    scrollbar-color: #cccccc;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 5px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #cccccc;
  border-radius: 10px;
}
.custom-desktop-banner {
  overflow-y: auto;
}
.custom-mobile-banner img {
  width: 100%;
}
</style>
<style>
.custom-desktop-banner video.video-js {
  height: calc((100vh - 210px) * 0.85) !important;
}
.new-design-banner video.video-js {
  margin-bottom: -1px;
}
</style>



// WEBPACK FOOTER //
// NewDesignBanner.vue?3a589cc1